import React, { useEffect, useState } from "react";
import customFetch from "./apicall/api";
import { useHistory } from "react-router-dom";
import moment from "moment";
import "antd/dist/antd.css";
import { Switch } from "antd";
import { logout, chkapiinput } from "./Utility";
import "../assets/css/BankRegisterNACH.css";


export default function NACHRegisterBank(props) {
  const history = useHistory();

  const [isVisible, setIsVisible] = useState("");
  const [call_duration, setCallDuration] = useState(0);
  const [preferred_mode, setPreferredMode] = useState("");
  const [status, setStatus] = useState(1);
  const [nach_flag, setNachFlag] = useState(props.location.state.nach_flag);
  const [isDisable, setIsDisable] = useState(true);
  const [isErrOpen, setIsErrOpen] = useState(false);
  const [api_error_message, setApiErrorMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [nach_mapid, setNachMapid] = useState("");
  const [hh_bank_details, setHHBankDetails] = useState([]);
  const [data, setDataState] = useState([]);
  const [isSpin, setIsSpin] = useState(false);
  const [flag, setFlag] = useState(0);
  const [NACH_form_upload, setNACHFormUpload] = useState("");
  const [ISNACH_form_upload, setISNACHFormUpload] = useState(false);
  const [pbutton, setPbutton] = useState(false);
  const [nbutton, setNbutton] = useState(false);
  const [dbutton, setDbutton] = useState(false);
  const [isOpenNach, setIsOpenNach] = useState(false);
  const [vendor_id, setVendorId] = useState(2);
  const [IPv4, setIPv4] = useState(null);
  const [latitude, setLat] = useState(null);
  const [longitude, setLng] = useState(null);
  const [search_text, setSearchText] = useState("");
  const [og_data, setOgData] = useState([]);
  const [isUpi, setIsUpi] = useState(true);

  // componentDidMount()
  useEffect(() => {
    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        setIsSpin(false);
        setFlag(1); // Set flag to 1 if accessed from Android

        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        console.log("AndroidInterface->", data);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }

    const uid = localStorage.getItem("in_userid");

    customFetch("https://geolocation-db.com/json/")
      .then((response) => {
        return response.json();
      }, "jsonp")
      .then((res) => {
        console.log(res);
        setIPv4(res.IPv4);
        setLat(res.latitude);
        setLng(res.longitude);
      })
      .catch((err) => console.log(err));
  }, []);

  function getBankHouseholdDetailsNACH() {
    setHHBankDetails([]);
    setIsSpin(true);

    const uid = localStorage.getItem("in_userid");
    const { api_token } =
      (props.location && props.location.state) || {};

    const params = {
      user_id: uid,
      household_number: search_text,
    };
    const queryParams = new URLSearchParams(params).toString();

    customFetch(
      process.env.REACT_APP_URL + "/household/bank/details/nach?" + queryParams,
      {
        method: "GET",
        headers: { "api-token": api_token },
      }
    )
      .then((res) => res.json())
      .then((json) => {
        console.log("loan_data - ", json);
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          history.push("/");
        }
        if (json.length === 0) {
          setIsSpin(false);
          setIsErrOpen(true);
          setApiErrorMessage("Data Not Found!");
        } else {
          setIsSpin(false);
          setHHBankDetails(json);
          setOgData(json);
        }
      })
      .catch((error) => console.log("error", error));
  }

  function setData(data) {
    var sflag = 0;
    setIsSpin(true);

    var message = "";

    if (data.length === 0) {
      message = "Bank Details are not Present!";
      setIsErrOpen(true);
    } else if (data.length === 1) {
      if (data[0].bank_name == null || data[0].bank_name === "") {
        message = "Bank Details Cannot be Blank!";
        setIsErrOpen(true);
      } else if (data[0].nach_status === "Registered") {
        message = "NACH already Registered, Deactive First";
        setIsErrOpen(true);
      } else {
        sflag = 1;
      }
    } else {
      var cdata = [];

      data.map((item) => {
        if (item.nach_status !== "Registered") {
          if (item.bank_name != null) {
            cdata.push(item);
          }
        }
      });

      data = cdata;

      if (data.length > 0) {
        sflag = 1;
      } else {
        sflag = 0;
      }
    }

    setDataState(data);

    if (sflag === 1) {
      var request = new XMLHttpRequest();
      request.onreadystatechange = (e) => {
        if (request.readyState !== 4) {
          return;
        }

        if (request.status === 200) {
          var res = JSON.parse(request.responseText);
          console.log("success", request.responseText);

          if (res["status"] === 1) {
            setPbutton(res["physical"] === "Y");
            setNbutton(res["netbanking"] === "Y");
            setDbutton(res["debitcard"] === "Y");

            setIsSpin(false);
            setIsOpenNach(true);
          } else {
            setIsErrOpen(true);
          }
        } else {
          console.warn("error");
        }
      };

      const { api_token } =
        (props.location && props.location.state) || {};

      const params = {
        ifsc_code: data[0].ifsc,
        partner_vendor_id: vendor_id,
      };
      const queryParams = new URLSearchParams(params).toString();

      request.open(
        "GET",
        process.env.REACT_APP_URL + "/check/bankdetails/nachType?" + queryParams
      );
      request.setRequestHeader("api-token", api_token);
      request.send();
    }
  }

  function openNachList(hh_no, regtype) {
    const { effective_designation_id, api_token } =
      (props.location && props.location.state) || {};

    console.log("regtype123", regtype);
    if (regtype === "NACH")
      history.push({
        pathname: "/NACH_Household_list",
        state: {
          api_token: api_token,
          hh_number: hh_no,
          lead_id: hh_no,
          e_id: effective_designation_id,
          b_id: localStorage.getItem("branch_id"),
          u_id: localStorage.getItem("in_userid"),
        },
      });
      
    if (regtype === "upi")
      history.push({
        pathname: "/UPI_autopay",
        state: {
          api_token: api_token,
          lead_id: hh_no,
          e_id: effective_designation_id,
          b_id: localStorage.getItem("branch_id"),
          u_id: localStorage.getItem("in_userid"),
        },
      });
  }

  const handleSearchInput = (e) => {
    setSearchText(e.target.value.toUpperCase());
    if (e.target.value === "") {
      setHHBankDetails(og_data);
    }
  };

  const onSearch = () => {
    if (search_text !== "") {
      if (search_text.length < 5) {
        setIsErrOpen(true);
        setApiErrorMessage("Search String Should be Atleast 5 Characters!");
      } else {
        getBankHouseholdDetailsNACH();
      }
    } else {
      setHHBankDetails(og_data);
    }
  };

  return (
    <>
      {isSpin ? (
        <div className="preloader">
          <div className="loader" ng-hide="data.length > 0"></div>
        </div>
      ) : (
        ""
      )}

      {/* ERROR POPUP */}
      <div
        className={
          isErrOpen
            ? "modal fade bd-example-modal-sm show mymodal"
            : "modal fade bd-example-modal-sm"
        }
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              onClick={() => setIsErrOpen(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{api_error_message}</p>
          </div>
        </div>
      </div>

      {/* NACH POPUP */}
      <div
        className={
          isOpenNach
            ? "modal fade bd-example-modal-sm show mymodal"
            : "modal fade bd-example-modal-sm"
        }
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Register NACH</h5>
              <button
                className="close"
                onClick={() => setIsOpenNach(false)}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <table>
                <tr>
                  <td>Bank</td>
                  <td>
                    <select>
                      {data.map((item) => {
                        return (
                          <option
                            value={
                              item.ifsc +
                              "|" +
                              item.bank_name +
                              "|" +
                              item.account_number
                            }
                          >
                            {item.ifsc +
                              " | " +
                              item.bank_name +
                              " | " +
                              item.account_number}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td>Vendor</td>
                  <td>
                    <select>
                      <option value="2">Razorpay</option>
                    </select>
                  </td>
                </tr>

                <tr>
                  <td>NACH Type</td>
                  <td>
                    {pbutton && (
                      <button className="btn btn-primary">Physical</button>
                    )}
                    {nbutton && (
                      <button className="btn btn-info">Netbanking</button>
                    )}
                    {dbutton && (
                      <button className="btn btn-warning">Debit Card</button>
                    )}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN UI */}

      <div className="call_detail container d-flex flex-column align-items-center">
        <div className="ca-header-box">
          <div className="collection_block_header">
            <div className="title-holder_bg">
              <div
                className="back_icon_bg"
                onClick={() => history.goBack()}
              >
                <img
                  src={require("../assets/images/back.png")}
                  className="back_icon_img"
                />
              </div>
              <h2>Household Bank Details</h2>
              {flag === 0 && (
                <div className="log-out">
                  <img
                    src={require("../assets/images/power-off.png")}
                    onClick={() => logout(null, null, true)}
                    alt=""
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <br />

        <div className="support_list_search_box">
          <span>Enter Household Number or Lead ID</span>
          <input
            className="form-control"
            type="text"
            value={search_text}
            onChange={handleSearchInput}
          />
          <button
            className="btn btn-nach-register rbtn btn-lg col-8 col-md-6 col-lg-4"
            onClick={onSearch}
          >
            Search
          </button>
        </div>

        {hh_bank_details.map((item, key) => {
          return (
            <div
              className="hh_white_block_nach"
              key={key}
            >
              <div className="name_hh_block_nach">
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <span className="name">
                    HH Name: {item.household_name}
                    <br />
                    Lead ID: {item.household_number}
                  </span>
                </div>
                          <button
                  className="upload_icon_bg_upi mx-1 pull-right"
                  onClick={(e) => {
                    e.stopPropagation();

                    const api_token =
                      (props.location &&
                        props.location.state &&
                        props.location.state.api_token) ||
                      localStorage.getItem("api_token");

                    const effective_designation_id =
                      (props.location &&
                        props.location.state &&
                        props.location.state.effective_designation_id) ||
                      localStorage.getItem("effective_designation");

                    history.push({
                      pathname: "/UPI_autopay",
                      state: {
                        api_token: api_token,
                        lead_id: item.household_number,
                        hh_number: item.household_number,
                        e_id: effective_designation_id,
                        b_id: localStorage.getItem("branch_id"),
                        u_id: localStorage.getItem("in_userid"),
                      },
                    });
                  }}
                >
                  <img src={require("../assets/images/nach_old.png")} className="nach_icon_img" />
                </button>

              <button
                    className="upload_icon_bg_nach mx-1 pull-right"
                    onClick={(e) => {
                      e.stopPropagation();
                      const api_token =
                        (props.location &&
                          props.location.state &&
                          props.location.state.api_token) ||
                        localStorage.getItem("api_token");

                      const effective_designation_id =
                        (props.location &&
                          props.location.state &&
                          props.location.state.effective_designation_id) ||
                        localStorage.getItem("effective_designation");

                      history.push({
                        pathname: "/NACH_Household_list",
                        state: {
                          api_token: api_token,
                          lead_id: item.household_number,
                          hh_number: item.household_number,
                          e_id: effective_designation_id,
                          b_id: localStorage.getItem("branch_id"),
                          u_id: localStorage.getItem("in_userid"),
                        },
                      });
                    }}
                  >
                    <img src={require("../assets/images/add.png")} className="nach_icon_img" />
                  </button>

              </div>
              <div className="amt_details_block2">
                {item.household_data.map((element) => {
                  return (
                    <div className="bank_details_nach">
                      <div className="bank_detail_nach">
                        <div className="bank_data">
                          <h6>
                            <b>{element.name_as_per_account}</b>
                          </h6>
                        </div>
                        <div className="bank_data">
                          {element.nach_status === "Not_Registered" ? (
                            <h5>
                              <span className="badge badge-warning">
                                {element.nach_status}
                              </span>
                            </h5>
                          ) : element.nach_status === "Uploaded" ||
                            element.nach_status === "Issued" ||
                            element.nach_status === "Initiated" ? (
                            <h5>
                              <span className="badge badge-primary">
                                {element.nach_status}
                              </span>
                            </h5>
                          ) : element.nach_status === "Registered" ? (
                            <h5>
                              <span className="badge badge-success">
                                {element.nach_status}
                              </span>
                            </h5>
                          ) : (
                            <h5>
                              <span className="badge badge-danger">
                                {element.nach_status}
                              </span>
                            </h5>
                          )}
                        </div>
                      </div>

                      <hr className="dotted_line_nach"></hr>

                      <div className="bank_detail_nach">
                        <div className="bank_data">
                          <h6>{element.bank_name}</h6>
                        </div>
                        <div className="bank_data">
                          <h6>{element.account_number}</h6>
                        </div>
                      </div>

                      <hr className="dotted_line_nach"></hr>

                      <div className="bank_detail_nach">
                        <div className="bank_data">
                          <h6>{element.ifsc}</h6>
                        </div>
                        <div className="bank_data">
                          <h6>{element.nach_type}</h6>
                        </div>
                      </div>

                      <div className="bank_detail_bottom_block">
                        <h6 className="nach_status_dt">
                          {element.nach_status_dt != null ||
                          element.nach_status_dt !== ""
                            ? element.nach_status_dt
                            : ""}
                        </h6>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
